import { getLocale, getLocalizedStrings } from '../../misc';
import {
  keySecurityCameraEquipment,
  keyMonitorAdditionalEquipment,
  keyProtectAdditionalEquipment,
  keyControlAdditionalEquipment,
  FibreInternet150CBMGroup1,
  FibreInternet150CBMGroup2,
  FibreInternet150,
  FibreInternet300,
  FibreInternet300CBMGroup1,
  FibreInternet300CBMGroup2,
  FibreInternet300MPP,
  fieldFiberInternet75G1,
  fieldFibreInternet75G2,
  fieldFibreInternet75MPP,
  fieldFiberInternetG1promo,
  fibreInternet15gPromo,
  fibreInternet3GPromo,
  fieldFiberInternetG1,
  fieldFiberInternetG2,
  fieldFiberInternetMPP,
  fieldFiberSwitch15GSwitch,
  fieldFiberSwitch1GSwitch,
  fieldSecureBusiness,
  fieldMobility,
  fieldBusinessConnect,
  fieldTelusBusinessWifiOption,
  fieldFiberInternet75BFPromo
} from '../../utils/constant';
import EN from '../../../EN.json';
import FR from '../../../FR.json';

const {
  quoteSummary: { optikTvOption },
  contentfulValues: {
    mbps15,
    mbps25,
    mbps75,
    mbps50,
    mbps100,
    mbps150,
    mbps300,
    mbps750,
    mbps1G,
    mbps15G,
    mbps3g,
    mbps3g3000,
    valueThreeMonthsFree,
    value3yLTOPromo,
    officePhone: {
      opBasic,
      op,
      opPlus,
      // sixTwelveMonthPromo,
      // sixTwelveMonthPromoBackpocket,
      standardMonthlyPricing,
      mtmPrice
    },
    fiveYearsTerm,
    yearsTerm,
    monthly,
    yes,
    telusOptikTvMonthlyRatePlanOptionValues: {
      tv,
      tvElite,
      tvBasic,
      core,
      basics,
      threeTheme,
      fourTheme
    },
    installationValues: { professionalInstall },
    secureBusiness: { monitor, protect, control, smart },
    secureBusinessOffers: {
      tenOffWirelene,
      twentyOffWireline,
      tenOffMpp,
      twentyOffMpp
    },
    telusOptikTvSetTopBoxValues: { rentBox, rent10Box, buyBox }
  }
} = getLocalizedStrings();

const locale = getLocale();

  const {
    WLS: { _valueFiveGSpeed,
      
     },
     contentfulValues: {
      officePhone: {
        opUtility
      },
     }
    
  } = locale === 'en-US' ? EN : FR;
export const internetCopperRates = {
  copperStaticIpSubnet1: 12,
  copperStaticIpSubnet5: 20,
  monthlyRates: {
    [mbps15]: 65,
    [mbps25]: 85,
    [mbps50]: 105,
    [mbps75]: 105,
    [mbps100]: 135,
    [mbps150]: 135
  },
  yearlyRates: {
    [mbps15]: 40,
    [mbps25]: 50,
    [mbps50]: 70,
    [mbps75]: 70,
    [mbps100]: 85,
    [mbps150]: 85
  },
  fiveYearlyRates: {
    [mbps15]: 40,
    [mbps25]: 50,
    [mbps50]: 70,
    [mbps75]: 70,
    [mbps100]: 85,
    [mbps150]: 85
  },
  limitedTimeOffers: {
    basicPromo: 40,
    enhancedPromo: 25,
    threeMonthsFree: 0,
    discountThreeMonthsFree: 15
  },
  regularOffers: {
    monthPromo: {
      [mbps15]: 15,
      [mbps25]: 25,
      [mbps50]: 25,
      [mbps75]: 25,
      [mbps100]: 40,
      [mbps150]: 40
    },
    yearlyPromo: {
      [mbps15]: 0,
      [mbps25]: 10,
      [mbps50]: 10,
      [mbps75]: 20,
      [mbps100]: 30,
      [mbps150]: 25
    }
  },
  limitedBasicOffers: {
    [mbps15]: 15,
    [mbps25]: 0,
    [mbps50]: 0,
    [mbps75]: 0,
    [mbps100]: 0,
    [mbps150]: 0
  },
  limitedEnhancedOffers: {
    [mbps15]: 0,
    [mbps25]: 0,
    [mbps50]: 25,
    [mbps75]: 25,
    [mbps100]: 0,
    [mbps150]: 0
  }
};
export const officePhoneForbornePricing = {
  [opBasic]: {
    [monthly]: 30, // change to 30
    [yearsTerm]: 25, // change to 25
    [fiveYearsTerm]: 10,
    // [sixTwelveMonthPromo]: -12,
    // [sixTwelveMonthPromoBackpocket]: -17,
    [standardMonthlyPricing]: 0
  },
  [op]: {
    [monthly]: 40,
    [yearsTerm]: 35,
    [fiveYearsTerm]: 15,
    // [sixTwelveMonthPromo]: -12,
    // [sixTwelveMonthPromoBackpocket]: -23,
    [standardMonthlyPricing]: 0
  },
  [opPlus]: {
    [monthly]: 50,
    [yearsTerm]: 45,
    [fiveYearsTerm]: 28,
    // [sixTwelveMonthPromo]: -12,
    // [sixTwelveMonthPromoBackpocket]: -23,
    [standardMonthlyPricing]: 0
  },
  [opUtility]: {
    [monthly]: 50,
    [yearsTerm]: 45,
    [fiveYearsTerm]: 10,
    [standardMonthlyPricing]: 0
  }
};

export const officePhoneNonForbornePricing = {
  [opBasic]: {
    price: 66,
    [mtmPrice]: 0,
    // [sixTwelveMonthPromo]: -12
  },
  [op]: {
    price: 75,
    // [sixTwelveMonthPromo]: -15,
    [mtmPrice]: 0
  },
  [opPlus]: {
    price: 85,
    // [sixTwelveMonthPromo]: -15,
    [mtmPrice]: 0
  },
  [opUtility]: {
    price: 66,
    [mtmPrice]: 0
  }
};

export const longDistanceAddOns = {
  '150 CAN/US Minutes ($5)': 5,
  '500 International Minutes ($10)': 10,
  'Unlimited CAN/US Package ($15)': 15
};

export default internetCopperRates;

export const internetFibreRates = {
  staticIPRequired: 12,
  staticIpSubnet1: 12,
  staticIpSubnet5: 20,
  accessPointRate: 15,
  staticIp5:12,
  staticIpDynamic5: 0,
  staticIpSubnet0: 0,

  accessPointsOneTimeRate: 75,
  threeYearLtoPromoDiscount: -65,
  fibreInternet15gPromoDiscount: -75,
  fibreInternet3gPromoDiscount: -130,
  fibreInternet5gPromoDiscount: 95,
  fibre1_5GSwitchOffer: 50,
  billCredit100: 100,
  billCredit200: 200,
  buyoutBillCredit300: 300,
  buyoutBillCredit600: 600,
  highSpeedBillCredit600: 600,
  highSpeedBillCredit800: 800,
  highSpeedBillCredit900: 900,
  monthlyRates: {
    [mbps15]: 65,
    [mbps25]: 85,
    [mbps75]: 105,
    [mbps150]: 135,
    [mbps300]: 155,
    [mbps750]: 205,
    [mbps1G]: 220,
    [mbps15G]: 230,
    [mbps3g]: 300,
    [mbps3g3000]: 300,
    [_valueFiveGSpeed]: 320
  },
  yearlyRates: {
    [mbps15]: 40,
    [mbps25]: 50,
    [mbps75]: 70,
    [mbps150]: 85,
    [mbps300]: 110,
    [mbps750]: 140,
    [mbps1G]: 160,
    [mbps15G]: 180,
    [mbps3g]: 180,
    [mbps3g3000]: 240,
    [_valueFiveGSpeed]: 260
  },
  yearlyRatesAlbertaBC:{
    '3yearTerm': {
      [mbps150]: 75,
      [mbps300]: 85,
      [mbps1G]: 105,
      [mbps15G]: 120,
      [mbps3g3000]: 135,
      [_valueFiveGSpeed]: 260
    },
    '5yearTerm': {
      [mbps150]: 75,
      [mbps300]: 85,
      [mbps1G]: 85,
      [mbps15G]: 95,
      [mbps3g3000]: 105,
      [_valueFiveGSpeed]: 260
    }
  },
  yearlyRatesBundleDiscounts: {
    [mbps15]: 10,
    [mbps25]: 10,
    [mbps75]: 10,
    [mbps150]: 10,
    [mbps300]: 10,
    [mbps750]: 10,
    [mbps1G]: 10,
    [mbps15G]: 10,
    [mbps3g]: 10,
    [mbps3g3000]: 10,
    [_valueFiveGSpeed]: 0
  },

  yearlyRatesQuebec: {
    [mbps15]: 40,
    [mbps25]: 50,
    [mbps75]: 70,
    [mbps150]: 85,
    [mbps300]: 95,
    [mbps750]: 140,
    [mbps1G]: 105,
    [mbps15G]: 180,
    [mbps3g]: 180,
    [mbps3g3000]: 240
  },
  yearlyRatesBundledWifiQuebec: {
    [mbps15]: 0,
    [mbps25]: 0,
    [mbps75]: 0,
    [mbps150]: 10,
    [mbps300]: 10,
    [mbps750]: 0,
    [mbps1G]: 10,
    [mbps15G]: 0,
    [mbps3g]: 0,
    [mbps3g3000]: 0
  },
  yearlyRatesBundledForWifiQuebec: {
    [mbps15]: 0,
    [mbps25]: 0,
    [mbps75]: 0,
    [mbps150]: 25,
    [mbps300]: 25,
    [mbps750]: 0,
    [mbps1G]: 25,
    [mbps15G]: 0,
    [mbps3g]: 0,
    [mbps3g3000]: 0
  },
  yearlyRatesBundleDiscountsQuebec: {
    [mbps15]: 10,
    [mbps25]: 10,
    [mbps75]: 10,
    [mbps150]: 0,
    [mbps300]: 0,
    [mbps750]: 10,
    [mbps1G]: 0,
    [mbps15G]: 10,
    [mbps3g]: 10,
    [mbps3g3000]: 10
  },
  yearlyRatesBundleDiscountsForQuebec: {
    [mbps15]: 10,
    [mbps25]: 10,
    [mbps75]: 10,
    [mbps150]: 10,
    [mbps300]: 25,
    [mbps750]: 10,
    [mbps1G]: 70,
    [mbps15G]: 10,
    [mbps3g]: 10,
    [mbps3g3000]: 10
  },
  yearlyRatesStandaloneDiscountsForQuebec: {
    [mbps15]: 10,
    [mbps25]: 10,
    [mbps75]: 10,
    [mbps150]: 10,
    [mbps300]: 25,
    [mbps750]: 10,
    [mbps1G]: 60,
    [mbps15G]: 10,
    [mbps3g]: 10,
    [mbps3g3000]: 10
  },
  yearlyRatesFibreWithBusinessWifiBundleDiscounts: {
    '5yearTerm': {
      [mbps15]: 10,
      [mbps25]: 10,
      [mbps75]: 10,
      [mbps150]: 10,
      [mbps300]: 10,
      [mbps750]: 10,
      [mbps1G]: 10,
      [mbps15G]: 10,
      [mbps3g]: 10,
      [mbps3g3000]: 10 + 60
    },
    '3yearTerm': {
      [mbps15]: 10,
      [mbps25]: 10,
      [mbps75]: 10,
      [mbps150]: 10,
      [mbps300]: 10 + 5,
      [mbps750]: 10,
      [mbps1G]: 10,
      [mbps15G]: 10,
      [mbps3g]: 10,
      [mbps3g3000]: 10 + 115
    },
    'Durée de 5 ans': {
      [mbps15]: 10,
      [mbps25]: 10,
      [mbps75]: 10,
      [mbps150]: 10,
      [mbps300]: 10,
      [mbps750]: 10,
      [mbps1G]: 10,
      [mbps15G]: 10,
      [mbps3g]: 10,
      [mbps3g3000]: 10 + 60
    },
    'Durée de 3 ans': {
      [mbps15]: 10,
      [mbps25]: 10,
      [mbps75]: 10,
      [mbps150]: 10,
      [mbps300]: 10 + 5,
      [mbps750]: 10,
      [mbps1G]: 10,
      [mbps15G]: 10,
      [mbps3g]: 10,
      [mbps3g3000]: 10 + 115
    }
  },
  yearlyFibreMppDiscounts: {
    crossSellOffer15: 5,
    mppFibreInternet1G: 10
  },
  limitedTimeOffers: {
    basicPromo: 40,
    enhancedPromo: 25,
    threeMonthsFree: 0,
    bundledPromo: 75
  },
  regularOffers: {
    monthPromo: {
      [mbps15]: 15,
      [mbps25]: 25,
      [mbps75]: 25,
      [mbps150]: 40,
      [mbps300]: 35,
      [mbps750]: 55,
      [mbps1G]: 50,
      [mbps15G]: 40
    },
    yearlyPromo: {
      [mbps15]: 0,
      [mbps25]: 10,
      [mbps75]: 10,
      [mbps150]: 10,
      [mbps300]: 10,
      [mbps750]: 10,
      [mbps1G]: 80
    },
    yearlyStandalonePromo: {
      [mbps15]: 0,
      [mbps25]: 0,
      [mbps75]: 0,
      [mbps150]: 0,
      [mbps300]: 0,
      [mbps750]: 0,
      [mbps1G]: 70
    },
    yearlyLimited3GPromo: {
      [valueThreeMonthsFree]: 0,
      [value3yLTOPromo]: 0
    }
  },
  threeYearBusinessWifiRates: {
    [mbps15]: 0,
    [mbps25]: 0,
    [mbps75]: 0,
    [mbps150]: 0,
    [mbps300]: 0,
    [mbps750]: 0,
    [mbps1G]: 0,
    [mbps15G]: 0,
    [mbps3g3000]: 40,
    [_valueFiveGSpeed]: 0
  },
  fiveYearBusinessWifiRates: {
    [mbps15]: 0,
    [mbps25]: 0,
    [mbps75]: 0,
    [mbps150]: 0,
    [mbps300]: 0,
    [mbps750]: 0,
    [mbps1G]: 0,
    [mbps15G]: 0,
    [mbps3g3000]: 40
  },
  limitedMonthlyOffers: {
    [mbps15]: 0,
    [mbps25]: 0,
    [mbps75]: 50,
    [mbps150]: 0,
    [mbps300]: 0,
    [mbps750]: 0,
    [mbps1G]: 0
  },
  limitedYearlyOffers: {
    [mbps15]: 0,
    [mbps25]: 0,
    [mbps75]: 25,
    [mbps150]: 0
  },
  limitedproductSelection: {
    [fieldSecureBusiness]: 0,
    [fieldMobility]: 0,
    [fieldBusinessConnect]: 0,
    [fieldTelusBusinessWifiOption]: 5
  },
  limitedYearlyOffersFibreStandalone: {
    [fieldFiberInternetG1promo]: 65,
    [fieldFiberInternetG1]: 70,
    [fieldFiberInternetG2]: 70,
    [fieldFiberInternetMPP]: 70,
    [fieldFiberSwitch1GSwitch]: 50
  },
  limitedYearlyOffersFibreBundled: {
    '3 Months Free': 65,
    [fieldFiberInternetG1promo]: 65,
    [fibreInternet15gPromo]: 0,
    [fibreInternet3GPromo]: 0,
    [fieldFiberInternetG1]: 70,
    [fieldFiberInternetG2]: 65,
    [fieldFiberInternetMPP]: 65,
    [fieldFiberSwitch1GSwitch]: 50
  },
  limitedYearlyOffers15G: {
    '3 Months Free': 65,
    [fieldFiberSwitch15GSwitch]: 50
  },
  limitedOfferFI: {
    [fieldFiberInternet75BFPromo]: 10,
    [fieldFiberInternet75G1]: 10,
    [fieldFibreInternet75G2]: 5,
    [fieldFibreInternet75MPP]: 5
  },
  limitedYearlyOffersFibre150: {
    [FibreInternet150CBMGroup1]: 10,
    [FibreInternet150CBMGroup2]: 5,
    [FibreInternet150]: 15
  },
  limitedYearlyOffersFibre300: {
    '3 Months Free': 25,
    [FibreInternet300]: 25,
    [FibreInternet300CBMGroup1]: 10,
    [FibreInternet300CBMGroup2]: 5,
    [FibreInternet300MPP]: 5
  }
};

export const optikTvRatesMonthlyBT = {
  [optikTvOption.tvBasic]: 30,
  [optikTvOption.tv]: 65,
  [optikTvOption.tvElite]: 85,
  [optikTvOption.core]: 40,
  [optikTvOption.basics]: 25,
  [optikTvOption.threeTheme]: 63,
  [optikTvOption.fourTheme]: 83
};

export const optikTvRatesThreeYearsBT = {
  [optikTvOption.tvBasic]: 30,
  [optikTvOption.tv]: 65,
  [optikTvOption.tvElite]: 85,
  [optikTvOption.core]: 30,
  [optikTvOption.basics]: 25,
  [optikTvOption.threeTheme]: 55,
  [optikTvOption.fourTheme]: 68
};

export const optikTvRatesMonthly = {
  [tvBasic]: 30,
  [tv]: 65,
  [tvElite]: 85,
  [core]: 40,
  [basics]: 25,
  [threeTheme]: 63,
  [fourTheme]: 83
};

export const optikTvRatesThreeYears = {
  [tvBasic]: 30,
  [tv]: 65,
  [tvElite]: 85,
  [core]: 30,
  [basics]: 25,
  [threeTheme]: 55,
  [fourTheme]: 68
};

export const telusOptikTvPricing = {
  sixTwelveMonthPromo: {
    [tvBasic]: 0,
    [tv]: 10,
    [tvElite]: 10
  },
  promoDurationOptikTV: {
    '6 months optik': '6 months',
    '12 months optik': '12 months'
  },
  winBackNoPrice: {
    [tvBasic]: 0,
    [professionalInstall]: 49.95,
    [tv]: 0,
    [tvElite]: 0,
    [core]: 0,
    [basics]: 0,
    [threeTheme]: 0,
    [fourTheme]: 0
  },
  topBoxes: {
    [tvBasic]: 5,
    [tv]: 5,
    [tvElite]: 5,
    [core]: 10,
    [basics]: 10,
    [threeTheme]: 10,
    [fourTheme]: 10
  },
  topBoxesThreeYearTerm: {
    [tvBasic]: 0,
    [tv]: 0,
    [tvElite]: 0,
    [core]: 0,
    [basics]: 10,
    [threeTheme]: 0,
    [fourTheme]: 0
  },
  topBoxesMonthlyTerm: {
    [tvBasic]: 5,
    [tv]: 0,
    [tvElite]: 0,
    [core]: 10,
    [basics]: 10,
    [threeTheme]: 10,
    [fourTheme]: 10
  },
  setTopBoxPricing: {
    [rentBox]: {
      monthly: 5,
      price: 0
    },
    [rent10Box]: {
      monthly: 10,
      price: 0
    },

    [buyBox]: {
      monthly: 0,
      price: 150
    }
  }
};

export const secureBusinessFields = {
  additionalEquipmentKeys: {
    [smart]: keySecurityCameraEquipment,
    [monitor]: keyMonitorAdditionalEquipment,
    [protect]: keyProtectAdditionalEquipment,
    [control]: keyControlAdditionalEquipment
  },
  secureBusinessPackageRates: {
    [monitor]: 70,
    [protect]: 80,
    [control]: 110,
    [smart]: 20
  },
  secureBusinessOfferDiscounts: {
    [tenOffMpp]: 10,
    [twentyOffMpp]: 20,
    [tenOffWirelene]: 10,
    [twentyOffWireline]: 20
  }
};
